/** @prettier */

var getQueryParam = require("./viewmodels").getQueryParam
var environment = require("../lib/environment")

var SENTRY_ENVIRONMENTS = {
  test: "Test",
  dev: "Development",
  prod: "Production",
};

/**
 * Checks if Sentry is present in the global context 
 */
function hasSentry() {
  return (typeof window.Sentry != "undefined") 
}

/**
 * Determine the sampling rate to use by page location/environment.
 *
 * @param {{location: string}} samplingContext
 * @returns
 */
function samplingRate(location) {
  if (!location || !location.hostname) {
    return 0;
  }

  var currentEnvironment = environment.environment(location.hostname);

  if (!currentEnvironment) {
    return 0;
  }

  var sampleRatesByEnvironment = {};
  sampleRatesByEnvironment[environment.DEV] = 1;
  sampleRatesByEnvironment[environment.TEST] = 0.25;
  sampleRatesByEnvironment[environment.PROD] = 0.1;

  return sampleRatesByEnvironment[currentEnvironment];
}

function tracesSampler(app, samplingContext) {
  if (app && app.featureToggles) {
    var featureToggles = app.featureToggles();
    if (featureToggles && featureToggles.sentryTracesSampleRate) {
      var parsedSampleRate = Number.parseFloat(
        featureToggles.sentryTracesSampleRate
      );
      return parsedSampleRate && parsedSampleRate >= 0 && parsedSampleRate <= 1
        ? parsedSampleRate
        : samplingRate(samplingContext.location);
    }
  } else {
    return samplingRate(samplingContext.location);
  }
}

/**
 * Generate Sentry configuration based on "environment" derived
 * from the document/window Location.
 *
 * @param {Location} location
 * @param {ViewModel} app the main Knockout View Model. For CEC, this is usually the `window.vm` object.
 * @returns {object} the Configuration for Sentry.init
 */
function sentryConfiguration(location, app) {
  var debug = getQueryParam("debug");
  var currentEnvironment = environment.environment(location.hostname);
  var version = document.getElementById('pkg-version').dataset.version

  if (debug || environment.isDevelopment()) {
    // Disable ALL default system integrations
    // See https://docs.sentry.io/platforms/javascript/configuration/integrations/default/#removing-an-integration
    console.log("Sentry Integrations disabled");

    // Much of our code has Sentry hard-coded. Ideally, we'd use a wrapper
    // over Sentry rather than monkey patch.
    window.Sentry.captureException = console.trace;
    window.Sentry.captureMessage = console.trace;


    return {
      // dsn: null,
      defaultIntegrations: false,
      environment: SENTRY_ENVIRONMENTS[currentEnvironment],
      dsn:
        "https://6060a8f35a4c476ba02c9a312927a87e@o139457.ingest.sentry.io/1201282",
      // integrations: [new Sentry.Integrations.BrowserTracing()]
      release: "cec@" + version || "unknown",
      tracesSampleRate: 1,
      // integrations: function (integrations) {
      //   return [
      //     new Sentry.Integrations.GlobalHandlers({
      //       onerror: false,
      //       onunhandledexception: false,
      //     }),
      //     new Sentry.Integrations.BrowserTracing()
      //   ];
      // },
    };
  }


  var configuration = {
    environment: SENTRY_ENVIRONMENTS[currentEnvironment],
    dsn:
      "https://6060a8f35a4c476ba02c9a312927a87e@o139457.ingest.sentry.io/1201282",
    maxBreadcrumbs: 10,
    release: "cec@" + version || "unknown",
    // integrations: [new Sentry.Integrations.BrowserTracing()],
    sampleRate: samplingRate(location),
    tracesSampler: function (samplingContext) {
      return tracesSampler(app, samplingContext);
    },
  };

  return configuration;
}

var initSentry = function () {
  if (hasSentry()) {
    window.Sentry.init(sentryConfiguration(window.location, window.vm));

    window.vm.selectedLocationIds.subscribe(function (ids) {
      window.Sentry.setExtra("locationId", ids && ids.length > 0 ? ids.join(",") : "");
    });
  }
};

/**
 * Retrieves the current Transaction
 * @returns 
 */
function tracingCurrentTransaction() {
  return (hasSentry() && window.Sentry.getCurrentHub) ? window.Sentry.getCurrentHub().getScope().getTransaction() : null;
}

/**
 * Create a span in the current Transaction
 * 
 * @param {object} spanOptions 
 */
function tracingAttachSpanToCurrentTransaction(spanOptions) {
  var currentTransaction = tracingCurrentTransaction();
  return (currentTransaction) ? currentTransaction.startChild(spanOptions) : null
}

function tracingTransaction(transactionContext) {
  return (hasSentry()) ? window.Sentry.startTransaction(transactionContext) : null
}

module.exports = {
  "initSentry": initSentry,
  "samplingRate": samplingRate,
  "sentryConfiguration": sentryConfiguration,
  "tracingAttachSpanToCurrentTransaction": tracingAttachSpanToCurrentTransaction,
  "tracingTransaction": tracingTransaction
};
